"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("../../HighchartsPlus");
var React = __importStar(require("react"));
var highcharts_1 = __importDefault(require("highcharts"));
var react_resize_detector_1 = __importDefault(require("react-resize-detector"));
var utils_1 = require("../../utils");
var series_1 = require("../series");
var parts_1 = require("../parts");
/**
 * Chart is the main data visualization component in Forge UI.
 *
 * This component requires a commercial license. To find out more about licensing costs write an email to
 * [Martin Hlucka](mailto:Martin.Hlucka@honeywell.com)
 * @nonfree
 * @child ./parts/Credits/Credits.ts
 * @child ./parts/Legend/Legend.ts
 * @child ./parts/Pane/Pane.ts
 * @child ./parts/PlotBand/PlotBand.ts
 * @child ./parts/PlotLine/PlotLine.ts
 * @child ./parts/Title/Title.ts
 * @child ./parts/Subtitle/Subtitle.ts
 * @child ./parts/Tooltip/Tooltip.ts
 * @child ./parts/XAxis/XAxis.ts
 * @child ./parts/YAxis/YAxis.ts
 *
 * @child ./series/Area/Area.ts
 * @child ./series/Bar/Bar.ts
 * @child ./series/Bullet/Bullet.ts
 * @child ./series/Column/Column.ts
 * @child ./series/Donut/Donut.ts
 * @child ./series/Heatmap/Heatmap.ts
 * @child ./series/Line/Line.ts
 * @child ./series/Pie/Pie.ts
 * @child ./series/Scatter/Scatter.ts
 * @child ./series/Gauge/Gauge.ts
 *
 */
var Chart = /** @class */ (function (_super) {
    __extends(Chart, _super);
    function Chart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.updateHead = function (headOptions) {
            var previousOptions = JSON.stringify(_this.state.headOptions);
            var nextOptions = JSON.stringify(headOptions);
            if (previousOptions !== nextOptions) {
                _this.setState({ headOptions: headOptions });
            }
        };
        _this.genClasses = function () {
            var className = _this.props.className;
            var classes = 'ui forge chart-wrap basic-chart';
            if (className) {
                classes += " " + className;
            }
            return classes;
        };
        _this.handleResize = function (width, height) {
            var chart = _this.state.chart;
            var onResize = _this.props.onResize;
            if (chart && Object.keys(chart).length) {
                try {
                    chart.reflow();
                }
                catch (e) { }
                _this.forceUpdate();
            }
            if (onResize) {
                onResize(width, height);
            }
        };
        _this.getCenterBlockContent = function () {
            var series = utils_1.typeChildren(_this.props.children).series;
            var content = null;
            var centerBlock = utils_1.getCenterBlock(series);
            if (centerBlock) {
                content = centerBlock.props.children;
            }
            return content;
        };
        _this.composeOptions = function (initialRun) {
            var props = _this.props;
            var _a = utils_1.typeChildren(props.children), xAxis = _a.xAxis, yAxis = _a.yAxis, legend = _a.legend, title = _a.title, tooltip = _a.tooltip, subtitle = _a.subtitle, credits = _a.credits, series = _a.series, includesHeatmap = _a.includesHeatmap, pane = _a.pane;
            var base = utils_1.baseOptions(props, { legend: legend, series: series, includesHeatmap: includesHeatmap });
            var legendModifiers = includesHeatmap
                ? { symbolHeight: undefined, symbolWidth: undefined }
                : {};
            var options = __assign(__assign({}, base), { series: series_1.seriesOptions(series, tooltip, initialRun), xAxis: parts_1.xAxisOptions(props, xAxis), yAxis: parts_1.yAxisOptions(props, yAxis), legend: parts_1.legendOptions(props, legend, legendModifiers), tooltip: parts_1.tooltipOptions(props, tooltip), credits: parts_1.creditsOptions(credits), pane: parts_1.paneOptions(pane) });
            var headOptions = {
                title: parts_1.titleOptions(props, title),
                subtitle: parts_1.subtitleOptions(props, subtitle)
            };
            return { options: options, headOptions: headOptions };
        };
        return _this;
    }
    Chart.prototype.componentDidMount = function () {
        var _a = this.composeOptions(true), options = _a.options, headOptions = _a.headOptions;
        var chart = highcharts_1.default.chart(this.highchartsRoot, options);
        this.setState({ chart: chart, headOptions: headOptions });
    };
    Chart.prototype.componentDidUpdate = function () {
        var _a = this.composeOptions(), options = _a.options, headOptions = _a.headOptions;
        this.updateHead(headOptions);
        this.state.chart.update(options, true, true);
    };
    Chart.prototype.componentWillUnmount = function () {
        var chart = this.state.chart;
        if (chart) {
            chart.destroy();
        }
    };
    Chart.prototype.render = function () {
        var _this = this;
        var _a = this.state, chart = _a.chart, headOptions = _a.headOptions;
        var centerBlockContent = this.getCenterBlockContent();
        return (React.createElement("div", { className: this.genClasses() },
            headOptions && React.createElement(parts_1.Head, __assign({}, headOptions, { rangeSelector: { enabled: false } })),
            React.createElement(parts_1.CenterBlock, { chart: chart, headOptions: headOptions, content: centerBlockContent }),
            React.createElement("div", { className: "highcharts-root", ref: function (ref) { return (_this.highchartsRoot = ref); } },
                React.createElement(react_resize_detector_1.default, __assign({ refreshMode: "throttle", refreshRate: 100, handleWidth: true, handleHeight: true, skipOnMount: false }, this.props.ResizerProps, { onResize: this.handleResize })))));
    };
    Chart.Credits = parts_1.Credits;
    Chart.Legend = parts_1.Legend;
    Chart.PlotBand = parts_1.PlotBand;
    Chart.PlotLine = parts_1.PlotLine;
    Chart.Subtitle = parts_1.Subtitle;
    Chart.Title = parts_1.Title;
    Chart.Tooltip = parts_1.Tooltip;
    Chart.XAxis = parts_1.XAxis;
    Chart.YAxis = parts_1.YAxis;
    Chart.CenterBlock = parts_1.CenterBlock;
    Chart.Pane = parts_1.Pane;
    Chart.Area = series_1.Area;
    Chart.AreaRange = series_1.AreaRange;
    Chart.Bar = series_1.Bar;
    Chart.Bullet = series_1.Bullet;
    Chart.CandleStick = series_1.CandleStick;
    Chart.Column = series_1.Column;
    Chart.ColumnRange = series_1.ColumnRange;
    Chart.Line = series_1.Line;
    Chart.ScatterPlot = series_1.Scatter;
    Chart.Pie = series_1.Pie;
    Chart.Donut = series_1.Donut;
    Chart.Heatmap = series_1.Heatmap;
    Chart.Gauge = series_1.Gauge;
    Chart.defaultProps = {
        animation: true,
        showLegend: true,
        showTooltips: true,
        colors: utils_1.defaultColors,
        dateTimeLabelFormats: utils_1.defaultDateTimeLabelFormats,
        series: {},
        pies: {},
        spacing: [10, 10, 15, 10],
        backgroundColor: '#FFFFFF00',
        chartType: 'basic',
        colorAxis: {
            minColor: '#D0E9F9',
            maxColor: '#1792e5'
        }
    };
    return Chart;
}(React.Component));
exports.default = Chart;
//# sourceMappingURL=Chart.js.map